import axiosBase from 'axios';
import { API_DEFAULT_CONTENT_TYPE, API_DEFAULT_TIMEOUT, CSRF_TOKEN_NAME } from '~/constants/api';

class Axios {
  constructor(location) {
    const axios = axiosBase.create({
      crossorigin: true,
      withCredentials: true,
      timeout: API_DEFAULT_TIMEOUT,
      headers: {
        'Content-Type': API_DEFAULT_CONTENT_TYPE,
        fullPathOrigin: location.href,
      },
      xsrfCookieName: CSRF_TOKEN_NAME,
      xsrfHeaderName: 'X-CSRF-TOKEN',
    });
    this.axios = axios;
  }

  get(path, params = {}, options = null) {
    // get/deleteはconfigのキーがparamsである必要がある
    return this.axios.get(path, { params }, options);
  }

  post(path, payload, options = null) {
    return this.axios.post(path, payload, options);
  }

  put(path, payload, options = null) {
    return this.axios.put(path, payload, options);
  }

  delete(path, params = {}, options = null) {
    // get/deleteはconfigのキーがparamsである必要がある
    return this.axios.delete(path, { params }, options);
  }

  static handleSuccess(response) {
    return response;
  }

  static handleError(error) {
    return Promise.reject(error);
  }
}

export default Axios;
